const config = {
  OPTIMISE_SCHEDULED_COLLECTIONS:
    !!process.env.REACT_APP_OPTIMISE_SCHEDULED_COLLECTIONS,
};

export default config;
